import type { FaireProductEntity } from "../../entity_types/product";

export const p_vf75rfq99w: FaireProductEntity = {
  token: "p_vf75rfq99w",
  type: "product",
  name: "Wild Herb Tonic - 3.5 oz Reed Diffuser",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/9539f034e3ba484d63b2aaca7675722b417c7c696d5c52a872f6108f2542197f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cb2188eecd9863fee04053b2f8f8b9985dc73606cd34bf8faeb9729426066ac9.jpeg",
    "https://cdn.faire.com/fastly/34f06e171ad9121b218c4441c63a6e459212373b9a922b5bde6c42c747afe0ec.jpeg",
    "https://cdn.faire.com/fastly/91c0f84eac41fd0ea6f233c05ae7bfe2c6d9787569d4d4ced5f3d713276df01a.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/3ec3b40ddf2d4f1d916cabf565664c386c5376775b70151546c6ca3cbe6a81fc.jpeg",
    "https://cdn.faire.com/fastly/3b84c7448c1fd4ba405db55ed07ec4e0f06691eb41a63bb53f5e1efcda2c2e1c.jpeg",
  ],
  priceDollars: 14.5,
  description:
    'Barefoot walks through wild herb gardens, cool mountain stream baths, crisp morning air. Lemon balm, thyme, orange, fir.\n\nLow-maintenance, flame-free, and always-on scent for entry ways, bathrooms, dorm rooms, and bedrooms.\n\nEach diffuser contains a 3.5 fl oz blend of naturally-derived and man-made fragrance oils in a 4 oz amber apothecary-inspired bottle. Includes a bundle of 9" long naturally-harvested rattan reeds to absorb and slowly release the fragrance. \n\nLasts approximately 3-4 months, flip reeds weekly.',
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:57.456Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
